import { Component, DoCheck, ViewEncapsulation } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { PromiseTrackerService } from './promise-tracker.service';

const inactiveStyle = style({
  opacity: 0,
  transform: 'translateY(-40px)'
});
const timing = '.3s ease';
export interface IBusyContext {
  message: string;
}

@Component({
  selector: 'div[bs-loading]',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css'],
  animations: [
    trigger('flyInOut', [
      transition('void => *', [inactiveStyle, animate(timing)]),
      transition('* => void', [animate(timing, inactiveStyle)])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class LoadingComponent implements DoCheck {
  wrapperClass: string;
  template: string;
  message: string;
  private lastMessage: string;

  constructor(private tracker: PromiseTrackerService) {}

  ngDoCheck() {
    if (this.message === this.lastMessage) {
      return;
    }
    this.lastMessage = this.message;
  }
  isActive() {
    return this.tracker.isActive();
  }
}
